



















































import Vue from "vue"
import { companyService, ICompanyService } from "@/model/service/company/company-service"
import Datatable, { DatatableOptions, IDatatable } from "@/components/datatable/Datatable.vue"
import { FieldDescription, FieldTypeEnum } from "@/model/entity/field-descriptor"

const B2B_FIELDS: FieldDescription[] = [
  {
    fieldName: "name",
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.company.name",
    displayed: true
  },
  {
    fieldName: "dswCode",
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.company.dsw_code",
    displayed: true
  },
  {
    fieldName: "status",
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.company.status",
    displayed: true
  },
  {
    fieldName: "b2b",
    fieldType: FieldTypeEnum.BOOLEAN,
    fieldPrettyName: "entity.company.b2b",
    displayed: true
  }
]

export interface IB2bAdministrationData {
  companyService: ICompanyService
  options: DatatableOptions
  fields: FieldDescription[]
  removeDialog: boolean
  selectedCompanyId: number
}

export default Vue.extend({
  components: {
    Datatable
  },
  data(): IB2bAdministrationData {
    return {
      companyService: companyService,
      // an empty operations object keeps the operations column without the built-in buttons
      options: {
        operations: {}
      },
      fields: B2B_FIELDS,
      removeDialog: false,
      selectedCompanyId: 0
    }
  },
  methods: {
    getData(page: number, size: number, datatable: IDatatable) {
      const vm = this
      vm.startLoad()
      vm.companyService
        .getB2BCompanies()
        .then(response => {
          vm.endLoad()
          const companies = response.data
          datatable.items = companies.slice((page - 1) * size, page * size)
          datatable.total = companies.length
        })
        .catch(error => {
          vm.endLoad()
          vm.$error(error.message)
        })
    },
    openRemoveDialog(selectedCompanyId: number) {
      this.removeDialog = true
      this.selectedCompanyId = selectedCompanyId
    },
    removeB2b(id: number) {
      const vm = this
      vm.startLoad()
      vm.companyService
        .disableCompanyB2B(id)
        .then(() => {
          vm.endLoad()
          vm.removeDialog = false
          vm.refreshData()
        })
        .catch(error => {
          vm.endLoad()
          vm.$error(error.message)
        })
    },
    refreshData() {
      const iDatatable = this.$refs.datatable as IDatatable
      iDatatable.refreshData()
    }
  }
})
